'use client';
import Image from 'next/image';

const galleryImages = [
  '/images/event-highlights/gallery-01.webp',
   '/images/event-highlights/gallery-02.webp',
   '/images/event-highlights/gallery-03.webp',
   '/images/event-highlights/gallery-04.webp',
  '/images/event-highlights/group-pic.webp',
  '/images/event-highlights/event-crowd.webp',
  '/images/event-highlights/professional.webp',
  '/images/event-highlights/welcome-to-event.webp',
  '/images/event-highlights/gamers-event.webp',
  '/images/event-highlights/network.webp',
  '/images/event-highlights/people.webp',
  '/images/event-highlights/event-discussion.webp',
  // '/images/event-highlights/selfie.webp',
  // '/images/event-highlights/after-event.webp',
  // '/images/event-highlights/number-exchnage-at-event.webp',
  // '/images/event-highlights/attendees.webp',


];

export default function GallerySection() {
  return (
<section data-component-id="src/app/GallerySection.tsx:27:0" data-component-path="src/app/GallerySection.tsx" data-component-line="27" data-component-file="GallerySection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22events-highlights%22%2C%22className%22%3A%22w-full%20p-6%20sm%3Ap-8%20md%3Ap-10%20lg%3Ap-%5B38px%5D%20sm%3Ap-4%20bg-primary-background%22%7D" id='events-highlights' className="w-full p-6 sm:p-8 md:p-10 lg:p-[38px] sm:p-4 bg-primary-background">
    
       {/* Heading */}
        <h2 data-component-id="src/app/GallerySection.tsx:30:8" data-component-path="src/app/GallerySection.tsx" data-component-line="30" data-component-file="GallerySection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22pb-10%20text-%5B32px%5D%20sm%3Atext-%5B38px%5D%20md%3Atext-%5B42px%5D%20lg%3Atext-%5B48px%5D%20font-bold%20leading-tight%20text-center%20text-text-white%22%2C%22textContent%22%3A%22Event%20Highlights%22%7D"
              className="pb-10 text-[32px] sm:text-[38px] md:text-[42px] lg:text-[48px] font-bold leading-tight text-center text-text-white"
              style={{ fontFamily: 'Gemunu Libre' }}
            >
              Event Highlights
            </h2>
      {/* Gallery Grid */}
      <div data-component-id="src/app/GallerySection.tsx:37:6" data-component-path="src/app/GallerySection.tsx" data-component-line="37" data-component-file="GallerySection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1200px%5D%20mx-auto%20grid%20grid-cols-2%20sm%3Agrid-cols-3%20md%3Agrid-cols-4%20gap-3%20sm%3Agap-4%22%7D" className="max-w-[1200px] mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4">
        {galleryImages.map((src, index) => (
          <div data-component-id="src/app/GallerySection.tsx:39:10" data-component-path="src/app/GallerySection.tsx" data-component-line="39" data-component-file="GallerySection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20group%20overflow-hidden%20rounded-lg%22%7D"
            key={index}
            className="relative group overflow-hidden rounded-lg"
          >
            <Image data-component-id="src/app/GallerySection.tsx:43:12" data-component-path="src/app/GallerySection.tsx" data-component-line="43" data-component-file="GallerySection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%5Bvar%3Asrc%5D%22%2C%22className%22%3A%22w-full%20h-full%20object-contain%20transition-transform%20duration-500%20group-hover%3Ascale-105%22%7D"
              src={src}
              alt={`Gallery ${index + 1}`}
              width={500}
              height={500}
              unoptimized
              className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
            />

            {/* Gradient Overlay */}
            <div data-component-id="src/app/GallerySection.tsx:53:12" data-component-path="src/app/GallerySection.tsx" data-component-line="53" data-component-file="GallerySection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20group-hover%3Aopacity-0%20transition-opacity%20duration-500%22%7D" className="absolute inset-0 group-hover:opacity-0 transition-opacity duration-500" />
          </div>
        ))}
      </div>
    </section>
  );
}
